import React, { useEffect, useState } from "react";
import {
  FaUserFriends,
  FaCar,
  FaCalendarAlt,
  FaTrashAlt,
  FaPlus,
  FaEye,
} from "react-icons/fa";
import "./ViewCompanies.scss";
import AddParent from "../../components/AddParent/AddParent";
import { useDispatch } from "react-redux";
import {
  fetchBookingByCompanyId,
  fetchCustomerByCompanyId,
} from "../../store/slices/thunk";
import { useNavigate, useParams } from "react-router-dom";
import { getTenantConfigFromStorage } from "../../helpers/tenantConfig";

const Viewcomanydetail = () => {
  const tenantConfig = getTenantConfigFromStorage();
  const parentLabel = tenantConfig.labels.parent;
  const childLabel = tenantConfig.labels.child;
  const parentLabelPlural = parentLabel.endsWith("y")
    ? `${parentLabel.slice(0, -1)}ies`
    : `${parentLabel}s`;
  const canAddChild = tenantConfig.features.canAddChild;
  const [activeTab, setActiveTab] = useState("parents");
  const { id } = useParams<any>();
  const [parentSearch, setParentSearch] = useState("");
  const [activeRideSearch, setActiveRideSearch] = useState("");
  const [allRideSearch, setAllRideSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const handleOpenModal = () => setShowModal(true);
  const ITEMS_PER_PAGE = 10;
  const [status, setStatus] = useState("");
      const [getCurrentUser, setCurrentUser] = useState<any>(null);
  
  const [totalCount, setTotalCount] = useState(0);
  const [totalRidesCount, setTotalRidesCount] = useState<number>(0);
  const [activeRidesCount, setActiveRidesCount] = useState<number>(0);
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const dispatch = useDispatch<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [CustomerByCompany, setAllCustomerByCompany] = useState<any>([]);
  const [bookingByCompany, setAllBookingByCompany] = useState<any>([]);
  const getBookingByCompany = async (tab?: string) => {
    try {
      let tripStatus = "";
      if (tab === "rides") {
        tripStatus = "onGoing";
      }
      const response: any = await dispatch(
        fetchBookingByCompanyId(id, tripStatus, page, 10, allRideSearch)
      );
      if (response?.isSuccess && response?.data?.data) {
        const fetchedData = response.data.data;
        if(tab === "rides" || (tab === 'parents' )){
          const ongoingRides = fetchedData.filter(
            (ride: any) => ride.tripStatus === "onGoing"
            
          );
          const activeCount = fetchedData.filter(
          (ride: any) =>ride.tripStatus === "onGoing").length;
          setActiveRidesCount(activeCount);
          setAllBookingByCompany(ongoingRides);
        }
        if(tab === "total" || (tab === 'parents')){
          setAllBookingByCompany(fetchedData);
          setTotalRidesCount(fetchedData.length || 0);
        }

        
      } else {
        setAllBookingByCompany([]);
        setTotalRidesCount(0);
        setActiveRidesCount(0);
      }
    } catch (error) {
      console.error("Error fetching customers by company ID:", error);
      setAllBookingByCompany([]);
      setTotalRidesCount(0);
      setActiveRidesCount(0);
    }
  };
useEffect(() => {
      const fetchUser = async () => {
          const userData = localStorage.getItem("user");
        if (userData) {
          setCurrentUser(JSON.parse(userData));
        }
      };
      fetchUser();
    }, []);
  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true);
      try {
        await getBookingByCompany(activeTab); // tab ke hisaab se call
      } catch (error) {
        console.error("Error fetching bookings:", error);
      } finally {
        setIsLoading(false);
      }
    }, 500); // debounce delay

    return () => {
      clearTimeout(handler); // cleanup debounce
    };
  }, [allRideSearch, activeTab]);

  const handleCloseModal = () => {
    setShowModal(false);
    getCustomerByCompany();
  };

  const getCustomerByCompany = async () => {
    try {
      const response: any = await dispatch(
        fetchCustomerByCompanyId(id, page, 10, parentSearch)
      );

      if (response?.isSuccess && response?.data?.data) {
        const fetchedData = response.data.data;
        setAllCustomerByCompany(fetchedData);
        setTotalCount(response.data.totalCount || fetchedData.length || 0);
      } else {
        setAllCustomerByCompany([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      setAllCustomerByCompany([]);
      setTotalCount(0);
    }
  };
  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true);
      try {
        await getCustomerByCompany();
      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        setIsLoading(false);
      }
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [dispatch, page, id, parentSearch]);

  const handleActiveTab = async (tab: string) => {
    setActiveTab(tab);
    if (tab === "rides" || tab === "total") {
      await getBookingByCompany(tab);
    }
    if (tab === "parents") {
      await getCustomerByCompany();
    }
  };

  const navigate = useNavigate();
  const handleCreateRide = () => {
    navigate("/add-booking");
  };

  return (
    <div className="view-company-container" style={{ display: "flex", flexDirection: "column" }}>
      {/* Top Summary Cards (Clickable Tabs) */}
      <div className="stats-container">
        <p className="companyName">
          {CustomerByCompany[0]?.company?.companyName}
        </p>
        <div
          className={`stat-card blue ${
            activeTab === "parents" ? "active" : ""
          }`}
          onClick={() => handleActiveTab("parents")}
        >
          <FaUserFriends className="stat-icon" />
          <div>
            <h3>{totalCount || 0}</h3>
            <p>{`Total ${parentLabelPlural}`}</p>
          </div>
        </div>

        <div
          className={`stat-card green ${activeTab === "rides" ? "active" : ""}`}
          onClick={() => handleActiveTab("rides")}
        >
          <FaCar className="stat-icon" />
          <div>
            <h3>{activeRidesCount || 0}</h3>
            <p>Active Rides</p>
          </div>
        </div>

        <div
          className={`stat-card purple ${
            activeTab === "total" ? "active" : ""
          }`}
          onClick={() => handleActiveTab("total")}
        >
          <FaCalendarAlt className="stat-icon" />
          <div>
            <h3>{totalRidesCount || 0}</h3>
            <p>Total Rides</p>
          </div>
        </div>
      </div>

      {/* TAB 1: Parent/Employee */}

      {activeTab === "parents" && (
        <div className="rides-section" style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
          <div className="rides-header" style={{ flexShrink: 0 }}>
            <div>
              <h2>{`Associated ${parentLabelPlural}`}</h2>
              <p>{`List of all registered ${parentLabelPlural.toLowerCase()}`}</p>
            </div>
            <div className="addParentsContainer">
                                                   {getCurrentUser && getCurrentUser.role !== 'schoolAdmin' && getCurrentUser.role !== 'superAdmin' && (
              <button className="create-btn btn-blue" onClick={handleOpenModal}>
                <FaPlus /> {`Add ${parentLabelPlural}`}
              </button>
                                                   )}
              <input
                type="text"
                placeholder={`search ${parentLabelPlural}`}
                onChange={(e) => setParentSearch(e.target.value)}
              />
            </div>
          </div>

          <div style={{ flex: 1, overflow: "auto" }}>
            {CustomerByCompany?.length === 0 ? (
              <p>No Data Found</p>
            ) : CustomerByCompany?.length > 0 ? (
              <div className="table-responsive">
                <table className="rides-table">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>{`${parentLabel.toUpperCase()} NAME`}</th>
                      <th>EMAIL</th>
                      {canAddChild && <th>{`${childLabel.toUpperCase()} COUNT`}</th>}
                      <th>LOCATION</th>
                      {/* <th>ACTION</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {CustomerByCompany?.map((item: any, index: number) => (
                      <tr key={item?.customerId || index}>
                        <td>{(page - 1) * 10 + index + 1}</td>

                        <td className="parent-name">
                          <span>{item?.name}</span>
                        </td>
                        <td>{item?.email}</td>

                        {canAddChild && <td>{item?.additionalInfo?.length || 0}</td>}
                        <td>{item?.address?.streetAddress || "N/A"}</td>

                        {/* <td>
                          <FaTrashAlt className="delete-icon" />
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p style={{ textAlign: "center", padding: "20px" }}>
                No bookings available
              </p>
            )}
          </div>
          <nav style={{ flexShrink: 0 }}>
            <ul className="pagination  mt-3 justify-content-center">
              <li className={`page-item ${page === 1 && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"}`}
                >
                  <button className="page-link" onClick={() => setPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}

              {pageCount > 5 && (
                <>
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() => setPage(pageCount)}
                    >
                      {pageCount}
                    </button>
                  </li>
                </>
              )}

              <li className={`page-item ${page === pageCount && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {/* TAB 2: Active Rides */}
      {activeTab === "rides" && (
        <div className="rides-section">
          <div className="rides-header">
            <div>
              <h2>Active Rides</h2>
              <p>Current ongoing and scheduled rides</p>
            </div>
            <div className="addParentsContainer">
                                                                 {getCurrentUser && getCurrentUser.role !== 'schoolAdmin' && getCurrentUser.role !== 'superAdmin' && (

              <button className="create-btn" onClick={handleCreateRide}>
                <FaPlus /> Create New Ride
              </button>
                                                                 )}
              <input
                type="text"
                placeholder="search Active Rides"
                onChange={(e) => setAllRideSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="rides-table">
              <thead>
                <tr>
                  <th>NAME</th>
                  <th>DATE</th>
                  <th>{parentLabel.toUpperCase()}</th>
                  <th>TIME</th>
                  <th>ROUTE</th>
                  <th>DRIVER</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {bookingByCompany?.length === 0 ? (
                  <p>No Data Found</p>
                ) : bookingByCompany?.length > 0 ? (
                  bookingByCompany?.map((ride: any, index: number) => (
                    <tr key={index}>
                      <td>
                        <strong>{ride?.tripName || "N/A"}</strong>
                      </td>
                      <td>
                        {ride?.tripStartDate
                           ? new Date(
                        ride?.tripStartDate
                      ).toLocaleDateString("en-GB")
                          : "N/A"}
                      </td>

                      <td>{ride?.customer?.length || "N/A"}</td>
                      <td>
                        {ride?.startTime
                          ? new Date(
                              `1970-01-01T${ride?.startTime}`
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "N/A"}
                      </td>

                      <td>
                        {" "}
                        <span>
                          {ride?.startLocation?.streetAddress || "N/A"} to{" "}
                          {ride?.endLocation?.streetAddress}
                        </span>
                      </td>
                      <td>
                        <strong>{ride?.driver?.driverName || "N/A"}</strong>
                        <br />
                        {ride?.vehicle?.vehicleNumber || ""}
                      </td>
                      <td>
                        <span
                          className={`status ${
                            ride?.status?.toLowerCase() || "unknown"
                          }`}
                        >
                          {ride?.status || "Unknown"}
                        </span>
                      </td>
                      <td>
                        <FaEye className="view-icon" onClick={() => navigate(`/view-Detail/${ride.activityLogId}`)}/>{" "}
                        {/* <FaTrashAlt className="delete-icon" /> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={8}
                      style={{ textAlign: "center", padding: "15px" }}
                    >
                      No rides found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* TAB 3: Total Rides */}
      {activeTab === "total" && (
        <div className="rides-section">
          <div className="rides-header">
            <div>
              <h2>All Rides History</h2>
              <p>Complete history of all rides</p>
            </div>
            <div className="addParentsContainer">
              <select
                className="status-dropdown"
                onChange={(e: any) => setStatus(e.target.value)}
              >
                <option>All Status</option>
                <option>In Progress</option>
                <option>Scheduled</option>
                <option>Completed</option>
              </select>
              <input
                type="text"
                placeholder="search All Rides"
                onChange={(e) => setAllRideSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="rides-table">
              <thead>
                <tr>
                  <th>NAME</th>
                  <th>DATE</th>
                  <th>{parentLabel.toUpperCase()}</th>
                  <th>TIME</th>
                  <th>ROUTE</th>
                  <th>DRIVER</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {bookingByCompany?.length > 0 ? (
                  bookingByCompany?.map((ride: any, index: number) => (
                    <tr key={ride?.rideId || index}>
                      <td>
                        <strong>{ride?.tripName || "N/A"}</strong>
                      </td>
                      <td>
                        {ride?.tripStartDate
                           ? new Date(
                        ride?.tripStartDate
                      ).toLocaleDateString("en-GB")
                          : "N/A"}
                      </td>

                      <td>{ride?.customer?.length || "N/A"}</td>
                      <td>
                        {ride?.startTime
                          ? new Date(
                              `1970-01-01T${ride?.startTime}`
                            ).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "N/A"}
                      </td>

                      <td>
                        {" "}
                        <span>
                          {ride?.startLocation?.streetAddress || "N/A"} to{" "}
                          {ride?.endLocation?.streetAddress}
                        </span>
                      </td>
                      <td>
                        <strong>{ride?.driver?.driverName || "N/A"}</strong>
                        <br />
                        {ride?.vehicle?.registrationNumber || ""}
                      </td>
                      <td>
                        <span
                          className={`status ${
                            ride?.status?.toLowerCase() || "unknown"
                          }`}
                        >
                          {ride?.status || "Unknown"}
                        </span>
                      </td>
                      <td>
                        <FaEye onClick={() => navigate(`/view-Detail/${ride.activityLogId}`)} className="view-icon" />{" "}
                        {/* <FaTrashAlt className="delete-icon" /> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={9}
                      style={{ textAlign: "center", padding: "15px" }}
                    >
                      No rides found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {showModal && <AddParent onClose={handleCloseModal} companyId={id} />}
    </div>
  );
};

export default Viewcomanydetail;
